// extracted by mini-css-extract-plugin
export var buttonContent = "_2y-0";
export var centered = "_2y-1";
export var centeredFlex = "_2y-2";
export var errorText = "_2y-3";
export var icon = "_2y-4";
export var iconButtonContent = "_2y-5";
export var monospace = "_2y-6";
export var padded = "_2y-7";